import { defaultEmployeeFormValues, EmployeeFormValues } from "../common/EmployeeFormValues";
import { defaultCriticalIllnessFormValues, CriticalIllnessFormValues } from "./CriticalIllnessFormValues";
import { Language } from "../enums/Language";
import { ConditionType } from "../enums/ConditionType";
import { TreatingPhysician } from "../domain/TreatingPhysician";
import { Illness } from "../enums/Illness";

export type CriticalIllnessEmployeeFormValues = EmployeeFormValues & CriticalIllnessFormValues & {
    textPermission: boolean,
    preferredLanguage: Language,
    otherLanguage: string,
    claimDates: [{
        startDate: string
    }],
    conditionType: ConditionType,
    illnesses: Illness[],
    medicalAssistanceWithPregnancy: string,
    dependents: string,
    hasBeenHospitalized: boolean,
    firstVisit: string,
    treatingPhysicians: TreatingPhysician[],
    hipaaConsent: boolean,
    confidentialMessages: string,
    permissionContactName: string,
    relationshipType: string,
    otherRelationshipDescription: string,
    representativeAuthority: string,
    authorityDescription: string,
    authorityDocumentation: string,
    facilityName: string,
    facilityPhoneNumber: string,
}

export const defaultCriticalIllnessEmployeeFormValues = {
    ...defaultEmployeeFormValues,
    ...defaultCriticalIllnessFormValues,
    textPermission: false,
    preferredLanguage: Language.ENGLISH,
    otherLanguage: '',
    claimDates: [{
        startDate: ''
    }],
    conditionType: ConditionType.SICKNESS,
    illnesses: [],
    medicalAssistanceWithPregnancy: "",
    dependents: '',
    hasBeenHospitalized: false,
    firstVisit: '',
    treatingPhysicians: [{
        physicianFirstName: '',
        physicianLastName: '',
        physicianPhoneNumber: '',
    }],
    hipaaConsent: false,
    confidentialMessages: '',
    permissionContactName: '',
    relationshipType: '',
    otherRelationshipDescription: '',
    representativeAuthority: 'No',
    authorityDescription: '',
    authorityDocumentation: '',
    facilityName: '',
    facilityPhoneNumber: ''
}
